<template>
  <el-row :gutter="20">
    <el-col :span="6" v-for="(item, index) in cardItems" :key="index">
      <div class="grid-content ep-bg-purple" />
    
        <el-card style="max-width: 480px">
          <template #header>Yummy hamburger</template>
          <img
            src="https://shadow.elemecdn.com/app/element/hamburger.9cf7b091-55e9-11e9-a976-7f4d0b07eef6.png"
            style="width: 100%"
          />
        </el-card>
    </el-col>

    <el-col :span="6" v-for="(item, index) in industryNew" :key="index">
      <div class="grid-content ep-bg-purple" />
        <el-card style="max-width: 480px">
          <template #header>{{item[0].article_title}}</template>
          <img
            :src="item[0].image.file_path"
            style="width: 100%"
          />
        </el-card>
     
    </el-col>
  </el-row>
  
</template>

<script>
import {industryNew} from '../api/api'
export default {
    name: 'EnterpriseDisplay',
    components: {

    },
    data() {
        return {
            // 创建包含5个元素的数组，对应5个卡片
            cardItems: Array(5).fill({}),
            industryNew:[]
        }
    },
    methods: {
       async getIndustryNew(){
            const data = {
                token: "",
                wxapp_id:'10001'
            }   
            industryNew(data).then(response => {
            console.log(response);
              console.log('response--------');
            //   console.log(response.data.data.list)
            this.industryNew=response.data.data.list.data
            console.log('response--+++++------');
             console.log(this.industryNew[0].article_title);   
             console.log(this.industryNew[0].image.file_path);   


            }).catch(error => {
                    console.error(error);
            });
        },
    },

        //     getCitylist(){
        //     const data = {
        //         token: "",
        //         wxapp_id: '10001'
        //     }
        //     cityList(data).then(response => {
        //        this.cityList=response.data.data.list
        //     }).catch(error => {
        //             console.error(error);
        //     });
        // },
    created() {
    this.getIndustryNew()
    window.addEventListener('resize', this.updateInnerWidth);
    }
}

</script>

<style>
.el-row {
  margin-bottom: 20px;
}
.el-row:last-child {
  margin-bottom: 0;
}
.el-col {
  border-radius: 4px;
}

.grid-content {
  border-radius: 4px;
  min-height: 36px;
}
</style>